export default "__VITE_ASSET__06d4dce9__"